export const MuiDialogGroup = {
  MuiDialog: {
    paperWidthXs: {
      minWidth: '480px',
    },
  },
  MuiDialogContent: {
    root: {
      paddingBottom: '40px',
    },
  },
  MuiDialogActions: {
    root: {
      margin: '0 24px 24px 24px',
      minWidth: '138px',
    },
    action: {
      padding: '12px 16px',
      fontWeight: 500,
      fontSize: '16px',
      letterSpacing: '0.5px',
      lineHeight: '20px',
      minWidth: '138px',
    },
  },
  MuiBackdrop: {
    root: {
      backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
  },
}
